import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-currency-types',
  templateUrl: './currency-types.component.html',
  styleUrls: ['./currency-types.component.css']
})
export class CurrencyTypesComponent implements OnInit {
    valutaId;

    public setting?: Setting;

    public itemsListCurrencyTypes: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.valutaId = this.stateService.getStateParams()['valuta_id'];
    }

    private async loadSetting() {
        if (!!this.valutaId) {
            this.setting = (await this.datatask.Post(1018, { valuta_id: this.valutaId }))[0];
        }
    }

    private async loadCurrencyTypes(): Promise<void> {
        if (!!this.setting) {
            this.itemsListCurrencyTypes = await this.datatask.Post(1019, { valuta_id: this.setting?.valuta_id });
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCurrencyTypes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    valuta_id: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('currencyTypes', {
//        templateUrl: 'views/components/views/currencyTypes/currencyTypes.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'currencyTypesService', function ($stateParams, utilityService, currencyTypesService) {
//            const vm = this;
//            let valutaId = $stateParams.valuta_id;

//            vm.model = {
//                setting: {},
//                itemsListCurrencyTypes: []
//            };

//            async function loadSetting() {
//                vm.model.setting = (await currencyTypesService.getCurrencyType({ valuta_id: valutaId }))[0];

//                return loadCurrencyTypes();
//            }

//            async function loadCurrencyTypes() {
//                if (utilityService.validateParmsValue(vm.model.setting.valuta_id) !== true) return;

//                return vm.model.itemsListCurrencyTypes = await currencyTypesService.listCurrencyTypes({ valuta_id: vm.model.setting.valuta_id });
//            }

//            vm.$onInit = function () {
//                loadSetting();
//            }
//        }]
//    });
//})();
